export const AUTO_SCAN_IDLE_MS = 200;
export const MAX_SCANNER_KEY_GAP_MS = 100;
export const ORDER_ID_PATTERN = /^\d{5,12}$/;

export const emptyScannerState = () => ({
    value: '', startedAt: 0, lastAt: 0, fast: true, multiInsert: false
});

export const advanceScannerState = (previous, value, now) => {
    const appended = value.length > previous.value.length && value.startsWith(previous.value);
    const addedCharacters = appended ? value.length - previous.value.length : value.length;
    const startsSequence = !appended || previous.value.length === 0;
    const keyGap = previous.lastAt ? now - previous.lastAt : 0;
    return {
        value,
        startedAt: startsSequence ? now : previous.startedAt,
        lastAt: now,
        fast: startsSequence ? true : previous.fast && keyGap <= MAX_SCANNER_KEY_GAP_MS,
        multiInsert: (startsSequence ? false : previous.multiInsert) || addedCharacters > 1
    };
};

export const looksLikeCompletedScan = state => {
    const averageGap = state.value.length > 1
        ? (state.lastAt - state.startedAt) / (state.value.length - 1)
        : Number.POSITIVE_INFINITY;
    return ORDER_ID_PATTERN.test(state.value)
        && (state.multiInsert || (state.fast && averageGap <= MAX_SCANNER_KEY_GAP_MS));
};
